<template>
    <div class="flex flex-col gap-5">
        <Error v-if="error" :text="error" />

        <InputField title="Email" type="text" name="email" placeholder="you@example.com" v-model="email" />
        <InputField
            title="Пароль"
            hint="Минимум 8 символов"
            type="password"
            name="password"
            v-model="password"
            :toggleable-password="true"
            :password-visible="arePasswordsVisible"
            :show-password-toggle="false"
        />
        <InputField
            title="Повтор пароля"
            hint="Минимум 8 символов"
            type="password"
            name="password-repeat"
            v-model="passwordRepeat"
            :toggleable-password="true"
            :password-visible="arePasswordsVisible"
            :show-password-toggle="false"
        />
        <button class="self-end text-sm font-medium text-emerald-700" type="button" @click="togglePasswordVisibility">
            {{ arePasswordsVisible ? 'Скрыть пароли' : 'Показать пароли' }}
        </button>
    </div>
</template>

<script setup lang="ts">
import { WebApp } from '@grammyjs/web-app'
import { onMounted } from '@vue/runtime-core'
import { ref } from 'vue'
import InputField from '../components/InputField.vue'
import api from '../composables/api'
import Error from '../components/Error.vue'
import { useError } from '../composables/error'

const error = ref('')
const email = ref('')
const password = ref('')
const passwordRepeat = ref('')
const arePasswordsVisible = ref(false)

const togglePasswordVisibility = () => {
    arePasswordsVisible.value = !arePasswordsVisible.value
}

const mainButtonClick = async () => {
    if (!email.value || !password.value) {
        return useError(`Заполните все поля`)
    }

    if (email.value.trim().includes(' ')) {
        return useError(`Email не должен содержать пробелов`)
    }

    const emailRegexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/
    if (!emailRegexp.test(email.value)) {
        return useError(`Email не должен содержать запрещенные символы`)
    }

    if (password.value.length < 8) {
        return useError('Минимальная длина пароля 8 символов')
    }

    if (!password.value.split('').find((char) => !isNaN(+char))) {
        return useError('Пароль должен содержать хотя бы одну цифру')
    }

    if (password.value !== passwordRepeat.value) {
        return useError('Поля "пароль" и "повтор пароля" не совпадают')
    }

    //    if (email.value.toLowerCase().endsWith('.ru')) {
    //        return useError('Почты в зоне .ru больше не поддерживаются')
    //    }

    WebApp.MainButton.showProgress()

    WebApp.showConfirm('Вы уверены что все данные введены верно?', async (isOk) => {
        if (!isOk) {
            return true
        }

        try {
            await api({
                path: '/accounts/webapp/add',
                method: 'PUT',
                body: {
                    login: email.value.trim(),
                    password: password.value
                },
                initData: WebApp.initData
            })

            WebApp.disableClosingConfirmation()
            WebApp.close()
        } catch (err: any) {
            if (err.message === 'AUTOACTIVATION.ACCOUNT.NO_REMAINING') {
                error.value = 'К сожалению, у вас не осталось слотов для добавления нового аккаунта'
            } else {
                error.value = err.message
            }

            useError('Ошибка, обратитесь в поддержку :(')
        }

        WebApp.MainButton.hideProgress()
    })
}

onMounted(() => {
    WebApp.MainButton.setText('Сохранить')
    WebApp.MainButton.show()
    WebApp.MainButton.onClick(mainButtonClick)
})

// watch(login, debounce(async () => {
//     const url = 'https://spclient.wg.spotify.com/signup/public/v1/account?validate=1&email=' + login.value
//     const res = await fetch(url, {
// 		method: 'GET',
// 		headers: {
// 			Accept: 'application/json',
//             'accept-language': 'en-US;q=1',
// 			'Content-Type': 'application/json',
// 		}
// 	})

// 	const json = await res.json()

//     if (json.status && json.status === 20) {
//         error.value = 'Этот аккаунт уже зарегистрирован'
//     }
// }, 500))
</script>
